import { agentCodeTestConfigPlan } from '../../../../atoms/atoms';
import type {
  AgentCodeTestConfigChange,
  AgentTestOperation,
} from '../../../../types';
import { pluralizeString } from '../../../../utils/common';
import { createPlanApprovalRenderer } from '../applyTestConfigPlanShared/ApplyTestConfigPlanToolRenderer';
import {
  formatCodeTestChangeLabel,
  formatCodeTestChangeSummary,
} from './utils';

const PREVIEW_PATH = '/test-management/code-agent-preview';
const RETURN_PATH = '/test-management';

const getHeaderLabel = (
  status: 'confirmed' | 'rejected' | undefined,
  operation: AgentTestOperation,
  count: number,
): string => {
  if (status === 'confirmed') return 'Pull request opened';
  if (status === 'rejected') return 'Plan rejected';
  if (operation === 'create') {
    return `Add ${pluralizeString(count, 'test', 'tests')}`;
  }
  if (operation === 'delete') {
    return `Delete ${pluralizeString(count, 'test', 'tests')}`;
  }
  return `Edit ${pluralizeString(count, 'test', 'tests')}`;
};

const getApproveLabel = (): string => 'Open PR';

const applyCodeTestConfigPlanApprovalRenderer =
  createPlanApprovalRenderer<AgentCodeTestConfigChange>({
    planAtom: agentCodeTestConfigPlan,
    previewPath: PREVIEW_PATH,
    returnPath: RETURN_PATH,
    formatChangeLabel: formatCodeTestChangeLabel,
    formatChangeSummary: formatCodeTestChangeSummary,
    getHeaderLabel,
    getApproveLabel,
  });

export default applyCodeTestConfigPlanApprovalRenderer;
